import { AxiosError } from 'axios';
import useSWR from 'swr';

import { WithStatusT } from '@consumer-frontend/nc-utils';

import { apiEndpoints } from '../lib';

type CashAdvanceDataResponseT = {
  draw_fee_percentage: string;
  eligible_to_draw: boolean;
  expected_funding_date: string;
  maximum_draw_amount: number;
  minimum_draw_amount: number;
};

export type CashAdvanceDataT = {
  drawFeePercentage: string;
  eligibleToDraw: boolean;
  expectedFundingDate: string;
  maximumDrawAmount: number;
  minimumDrawAmount: number;
};

export const useCashAdvanceData = () => {
  const {
    data,
    error,
    isLoading,
  } = useSWR<WithStatusT<CashAdvanceDataResponseT>, AxiosError>(
    apiEndpoints.dashboard.cashAdvanceData(),
  );

  const cashAdvanceData: CashAdvanceDataT | undefined = data
    ? {
      drawFeePercentage: data.draw_fee_percentage,
      eligibleToDraw: data.eligible_to_draw,
      expectedFundingDate: data.expected_funding_date,
      maximumDrawAmount: data.maximum_draw_amount,
      minimumDrawAmount: data.minimum_draw_amount,
    }
    : undefined;

  return {
    cashAdvanceData,
    error,
    isLoading,
    status: data?.status || error?.status,
  };
};
